export const ROLES = {
    ADMIN: "ADMIN",
    SUPER_ADMIN: "SUPER_ADMIN",
}